import useSWR from 'swr';

export function useCurrentUser() {
  const { data, isLoading: isLoadingUser } = useSWR(`account/get-user`);
  const user = data?.user;
  const totalStudents = data?.totalStudents;

  return { user, totalStudents, isLoadingUser };
}

export function useIsAllowed() {
  const { user, isLoadingUser } = useCurrentUser();

  function isAllowed(allowedRoles) {
    if (typeof allowedRoles === 'string') allowedRoles = [allowedRoles];
    if (!user || !Array.isArray(allowedRoles)) return false;
    return user.identityRoles.some((role) =>
      ['SystemAdministrator', 'SchoolAdministrator', ...allowedRoles].includes(
        role,
      ),
    );
  }

  return { isAllowed, isLoadingUser };
}
